import { Cartesian } from "@examspark/types";

export const roundToGrid = (position: number, axis: Cartesian.Axis) => {
  return generateTicksFromAxis(axis).reduce((prev, curr) =>
    Math.abs(curr - position) < Math.abs(prev - position) ? curr : prev,
  );
};

export const generateTicksFromAxis = (axis: Cartesian.Axis) => {
  const start = axis.min;
  const end = axis.max;
  const step = axis.tickDistance
    ? axis.tickDistance / ((axis.minorTicks ?? 0) + 1)
    : 1;

  // try to keep the numbers nice and round
  const e = step / 100;

  const ticks: number[] = [];

  // ensure you use epsilon to avoid floating point errors
  for (let i = start; i <= end + e; i += step) {
    ticks.push(Math.round(i / e) * e);
  }

  return ticks;
};
